<p>
  Die DATEV Schnittstelle ermöglicht Ihnen die Übertragung der Sammelrechnungen von Hageda-Stumpf an Ihre
  Finanzbuchhaltung. Nach erfolgreicher Authorisierung ist die Schnittstelle aktiviert und die Sammelrechnungen werden
  als Belegbilder automatisch an DATEV gesendet.
</p>

<ol>
  <li>
    Stellen Sie sicher, dass die Berechtigung für die Nutzung des DATEV <a
    href="https://www.datev.de/web/de/datev-shop/92902-belegbilderservice/">Belegbilderservice</a> gesetzt ist. Setzen
    Sie sich dafür ggf. mit Ihrer Steuerberatung in Verbindung
  </li>
  <li>
    Melden Sie sich durch Eingabe der unten stehenden Daten bei DATEV an:
  </li>
</ol>

<form [formGroup]="clientForm" (ngSubmit)="submitClientForm()" class="w-30 mt-l">
  <mat-form-field appearance="outline">
    <mat-label>Beraternummer</mat-label>
    <input matInput formControlName="berater" tabindex="3">
    <mat-error>Bitte geben Sie Ihre Beraternummer ein.</mat-error>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Mandantennummer</mat-label>
    <input matInput formControlName="client" tabindex="5">
    <mat-error>Bitte geben Sie Ihre Mandantennummer ein.</mat-error>
  </mat-form-field>

  <button mat-flat-button
          color="primary"
          type="submit"
          [disabled]="!clientForm.valid">
    Konfigurieren
  </button>
</form>
